import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { deleteFileById } from '../api/data-connectors/delete-file'
import { useNotification } from './useNotification'
import { useSelectedContext } from './useSelectedContext'

export function useDeleteFile() {
  const queryClient = useQueryClient()
  const { notify } = useNotification()
  const { t } = useTranslation()
  const { getFileSelection, updateFileSelection } = useSelectedContext()

  return useMutation({
    mutationFn: ({ fileId }: { fileId: string }) => deleteFileById(fileId),
    onSuccess: async (data, { fileId }) => {
      if (data?.isDeleted) {
        const selectedFile = getFileSelection(fileId)
        if (selectedFile) {
          updateFileSelection({ ...selectedFile, sections: null })
        }
        await queryClient.invalidateQueries({ queryKey: ['filepool'] })
        notify({ isSuccess: true, text: t('files.deleteSuccessToast'), position: 'bottom' })
      }
    },
    onError: () => {
      notify({ isSuccess: false, text: t('files.deleteFailureToast'), position: 'bottom' })
    },
  })
}
